import {useEffect, useState} from "react";
import {CheckIcon, SearchIcon, ThinCloseIcon} from "../../../components/icons/material-icons";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";

interface studentsInterface {
    studentId: number,
    name: string,
    className: string,
    selected: boolean,
}

export const AdminsPickAllowedForExtraPaymentModal = (props: {
    active: boolean,
    closeHandler: any,
    paymentId: string,
    specialList: number[],
    onDone: any,
}) => {
    const [loaded, setLoaded] = useState(false);
    const [list, setList] = useState([] as studentsInterface[]);
    const fetchList = (old: number[]) => {
        ShowProgressLoading();
        setLoaded(false);
        PostJSON(
            Apis.server + '/core/admins/center/class/get-students',
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: studentsInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                let lst = [] as studentsInterface[];
                if (d.list !== null)
                    d.list.forEach(e => {
                        const x = old.findIndex(o => o === e.studentId);
                        lst.push({
                            studentId: e.studentId,
                            selected: x > -1,
                            name: e.name,
                            className: e.className,
                        });
                    });
                setLoaded(true);
                setList(lst);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const _old = [...props.specialList];
        const isActive = props.active;
        if (isActive) {
            fetchList(_old);
            document.body.classList.add("body-no-scroll");
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const [search, setSearch] = useState('');
    useEffect(() => {
        if (!loaded)
            return;
        const filter = search.toUpperCase();
        const lst = document.querySelector('.special-students-of-sci-class-picker-modal1');
        const btns = (lst as HTMLDivElement).getElementsByTagName('button');
        for (let i = 0; i < btns.length; i++) {
            const b = btns[i].getElementsByTagName('span')[0];
            const v = b.innerHTML.toUpperCase();
            if (v.indexOf(filter) > -1)
                btns[i].style.display = "";
            else
                btns[i].style.display = "none";
        }
    }, [search]);
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={loaded ? {top: 20} : {}}>
                <div className="web-modal-header">
                    <div><b>انتخاب دانش‌آموزان متمایز</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="reports--select-employee">
                        {
                            loaded ?
                                <>
                                    <label>دانش‌آموزان خاص مجاز به پرداخت:</label>
                                    <div className="pick-device-search">
                                        <button><SearchIcon/></button>
                                        <input type="text"
                                               value={search}
                                               onChange={e => setSearch(e.currentTarget.value)}
                                               onBlur={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.remove('active')}
                                               onFocus={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.add('active')}
                                               className="f-roboto"
                                               placeholder={"جستجو براساس نام یا کلاس..."}
                                        />
                                    </div>
                                    <div className="special-students-of-sci-class-picker-modal1">
                                        {
                                            list.map((e, i) =>
                                                <button key={"JnFnNNsj929r73FF22" + i}
                                                        className={"techaran-checkbox" + (e.selected ? ' active' : '')}
                                                        onClick={() => {
                                                            ShowProgressLoading();
                                                            const old = e.selected;
                                                            PostJSON(
                                                                Apis.server + '/core/admins/extra/allowed/toggle',
                                                                {
                                                                    paymentId: props.paymentId,
                                                                    studentId: e.studentId,
                                                                    allow: old ? '0' : '1',
                                                                },
                                                                true,
                                                                (d: {
                                                                    result: string,
                                                                    reason: string | undefined,
                                                                }) => {
                                                                    HideProgressLoading();
                                                                    if (d.result !== 'OK') {
                                                                        if (d.reason === 'login')
                                                                            AuthRedirectAdmins();
                                                                        return;
                                                                    }
                                                                    setList(v => {
                                                                        let x = [...v];
                                                                        const id = x.findIndex(r => r.studentId === e.studentId);
                                                                        x[id].selected = !x[id].selected;
                                                                        return x;
                                                                    });
                                                                    ShowSnackbar(
                                                                        old ?
                                                                            'دانش‌آموز مورد نظر از لیست مجازها حذف شد.' :
                                                                            'دانش‌آموز به لیست مجازها اضافه شد.',
                                                                        'باشه',
                                                                        5000,
                                                                    );
                                                                },
                                                                () => {
                                                                },
                                                                AuthRedirectAdmins,
                                                            ).then(void 0);
                                                        }}>
                                                    <i><CheckIcon/></i>
                                                    <span>{e.name}<em>{(e.className === '' ? 'بدون کلاس' : `${e.className}`)}</em></span>
                                                </button>
                                            )
                                        }
                                    </div>
                                </> :
                                <div className="d-flex justify-content-center align-items-center"
                                     style={{padding: '70px 0'}}>
                                    <div className="spinner-border" style={{color: '#2b2b2b'}}/>
                                </div>
                        }
                    </div>
                </div>
            </div>
        </>
    );
};